import { render } from "./SelectLogo.vue?vue&type=template&id=3258a54e&scoped=true"
import script from "./SelectLogo.vue?vue&type=script&lang=js"
export * from "./SelectLogo.vue?vue&type=script&lang=js"

import "./SelectLogo.vue?vue&type=style&index=0&id=3258a54e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3258a54e"]])

export default __exports__